import _toConsumableArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { getRemediator, handleFailedResponse, isTerminalResponse, filterValuesForRemediation, getNextStep } from './util.js';
function getActionFromValues(values, idxResponse) {
  return Object.keys(idxResponse.actions).find(function (action) {
    return !!values.resend && action.includes('-resend');
  });
}
function removeActionFromValues(values) {
  return Object.assign(Object.assign({}, values), {
    resend: undefined
  });
}
function removeActionFromOptions(options, actionName) {
  var actions = options.actions || [];
  actions = actions.filter(function (entry) {
    if (typeof entry === 'string') {
      return entry !== actionName;
    }
    return entry.name !== actionName;
  });
  return Object.assign(Object.assign({}, options), {
    actions: actions
  });
}
function remediate(_x, _x2, _x3, _x4) {
  return _remediate.apply(this, arguments);
}
function _remediate() {
  _remediate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(authClient, idxResponse, values, options) {
    var _idxResponse, neededToProceed, interactionCode, _options, flow, remediator, actionFromValues, actionFromOptions, actions, _iterator, _step, _loop, _ret, terminal, nextStep, name, data, gr, _nextStep;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _idxResponse = idxResponse, neededToProceed = _idxResponse.neededToProceed, interactionCode = _idxResponse.interactionCode;
          _options = options, flow = _options.flow;
          if (!interactionCode) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", {
            idxResponse: idxResponse
          });
        case 4:
          remediator = getRemediator(idxResponse, values, options);
          actionFromValues = getActionFromValues(values, idxResponse);
          actionFromOptions = options.actions || [];
          actions = [].concat(_toConsumableArray(actionFromOptions), _toConsumableArray(actionFromValues && [actionFromValues] || []));
          if (!actions) {
            _context2.next = 28;
            break;
          }
          _iterator = _createForOfIteratorHelper(actions);
          _context2.prev = 10;
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var action, params, valuesWithoutExecutedAction, optionsWithoutExecutedAction, remediationAction;
            return _regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  action = _step.value;
                  params = {};
                  if (typeof action !== 'string') {
                    params = action.params || {};
                    action = action.name;
                  }
                  valuesWithoutExecutedAction = removeActionFromValues(values);
                  optionsWithoutExecutedAction = removeActionFromOptions(options, action);
                  if (!(typeof idxResponse.actions[action] === 'function')) {
                    _context.next = 14;
                    break;
                  }
                  _context.next = 8;
                  return idxResponse.actions[action](params);
                case 8:
                  idxResponse = _context.sent;
                  if (!(idxResponse.requestDidSucceed === false)) {
                    _context.next = 11;
                    break;
                  }
                  return _context.abrupt("return", {
                    v: handleFailedResponse(authClient, idxResponse, options)
                  });
                case 11:
                  if (!(action === 'cancel')) {
                    _context.next = 13;
                    break;
                  }
                  return _context.abrupt("return", {
                    v: {
                      idxResponse: idxResponse,
                      canceled: true
                    }
                  });
                case 13:
                  return _context.abrupt("return", {
                    v: remediate(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction)
                  });
                case 14:
                  remediationAction = neededToProceed.find(function (_ref) {
                    var name = _ref.name;
                    return name === action;
                  });
                  if (!remediationAction) {
                    _context.next = 22;
                    break;
                  }
                  _context.next = 18;
                  return idxResponse.proceed(action, params);
                case 18:
                  idxResponse = _context.sent;
                  if (!(idxResponse.requestDidSucceed === false)) {
                    _context.next = 21;
                    break;
                  }
                  return _context.abrupt("return", {
                    v: handleFailedResponse(authClient, idxResponse, options)
                  });
                case 21:
                  return _context.abrupt("return", {
                    v: remediate(authClient, idxResponse, values, optionsWithoutExecutedAction)
                  });
                case 22:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 13:
          if ((_step = _iterator.n()).done) {
            _context2.next = 20;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 15);
        case 15:
          _ret = _context2.t0;
          if (!_ret) {
            _context2.next = 18;
            break;
          }
          return _context2.abrupt("return", _ret.v);
        case 18:
          _context2.next = 13;
          break;
        case 20:
          _context2.next = 25;
          break;
        case 22:
          _context2.prev = 22;
          _context2.t1 = _context2["catch"](10);
          _iterator.e(_context2.t1);
        case 25:
          _context2.prev = 25;
          _iterator.f();
          return _context2.finish(25);
        case 28:
          terminal = isTerminalResponse(idxResponse);
          if (!terminal) {
            _context2.next = 31;
            break;
          }
          return _context2.abrupt("return", {
            idxResponse: idxResponse,
            terminal: terminal
          });
        case 31:
          if (remediator) {
            _context2.next = 43;
            break;
          }
          if (!options.step) {
            _context2.next = 40;
            break;
          }
          values = filterValuesForRemediation(idxResponse, options.step, values);
          _context2.next = 36;
          return idxResponse.proceed(options.step, values);
        case 36:
          idxResponse = _context2.sent;
          if (!(idxResponse.requestDidSucceed === false)) {
            _context2.next = 39;
            break;
          }
          return _context2.abrupt("return", handleFailedResponse(authClient, idxResponse, options));
        case 39:
          return _context2.abrupt("return", {
            idxResponse: idxResponse
          });
        case 40:
          if (!(flow === 'default')) {
            _context2.next = 42;
            break;
          }
          return _context2.abrupt("return", {
            idxResponse: idxResponse
          });
        case 42:
          throw new AuthSdkError("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(neededToProceed.reduce(function (acc, curr) {
            return acc ? acc + ' ,' + curr.name : curr.name;
          }, ''), "]\n    "));
        case 43:
          if (remediator.canRemediate()) {
            _context2.next = 46;
            break;
          }
          nextStep = getNextStep(authClient, remediator, idxResponse);
          return _context2.abrupt("return", {
            idxResponse: idxResponse,
            nextStep: nextStep
          });
        case 46:
          name = remediator.getName();
          data = remediator.getData();
          _context2.next = 50;
          return idxResponse.proceed(name, data);
        case 50:
          idxResponse = _context2.sent;
          if (!(idxResponse.requestDidSucceed === false)) {
            _context2.next = 53;
            break;
          }
          return _context2.abrupt("return", handleFailedResponse(authClient, idxResponse, options));
        case 53:
          values = remediator.getValuesAfterProceed();
          options = Object.assign(Object.assign({}, options), {
            step: undefined
          });
          if (!(options.useGenericRemediator && !idxResponse.interactionCode && !isTerminalResponse(idxResponse))) {
            _context2.next = 59;
            break;
          }
          gr = getRemediator(idxResponse, values, options);
          _nextStep = getNextStep(authClient, gr, idxResponse);
          return _context2.abrupt("return", {
            idxResponse: idxResponse,
            nextStep: _nextStep
          });
        case 59:
          return _context2.abrupt("return", remediate(authClient, idxResponse, values, options));
        case 60:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[10, 22, 25, 28]]);
  }));
  return _remediate.apply(this, arguments);
}
export { remediate };